import {
  CreateInvoiceEntity,
  InvoiceEntity,
} from '@/pages/privatePages/invoice/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

// POST /invoice/check-eligibility - why an invoice can't be created, first
// failed check only (checked in this order).
export enum InvoiceIneligibilityReason {
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  PROJECT_NAME_MISSING = 'PROJECT_NAME_MISSING',
  NO_PRODUCTS = 'NO_PRODUCTS',
  UNSUPPORTED_PROVIDER = 'UNSUPPORTED_PROVIDER',
  UNSUPPORTED_COUNTRY_OR_CURRENCY = 'UNSUPPORTED_COUNTRY_OR_CURRENCY',
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  PRODUCT_PRICING_NOT_FOUND = 'PRODUCT_PRICING_NOT_FOUND',
  NO_INVOICEABLE_ITEMS = 'NO_INVOICEABLE_ITEMS',
  PRODUCT_MISSING_XERO_ACCOUNT_CODE = 'PRODUCT_MISSING_XERO_ACCOUNT_CODE',
  XERO_CONTACT_NOT_FOUND = 'XERO_CONTACT_NOT_FOUND',
  XERO_CONTACT_NAME_MISMATCH = 'XERO_CONTACT_NAME_MISMATCH',
}

export type InvoiceEligibility = {
  isEligible: boolean;
  reason: InvoiceIneligibilityReason | null;
  // Safe to show to the user as is.
  message: string | null;
  details: Record<string, any> | null;
};

class InvoiceServiceClass extends BaseService<
  'invoice',
  InvoiceEntity,
  CreateInvoiceEntity
> {
  constructor() {
    super('invoice');
  }

  checkPreInvoicing = (payload: {
    projectId: string;
    productIds: string[];
  }): Promise<InvoiceEligibility> => {
    return APIService.post(`${this.path}/check-eligibility`, payload);
  };
}
export const invoiceService = new InvoiceServiceClass();
